<ng-container *ngIf="vm$ | async as vm">
    <ng-container *ngIf="vm.info">
        <div class="pc-text">
            <ng-container *msShowInEpcot="{ showInEpcot: false, module: module }">
                <a class="linkbox betslip-error add-header" *ngIf="!!vm.info.message">
                    <h4 class="theme-error-i">{{ vm.info.message }} {{ vm.info.failedInfo ?? '' }}</h4>
                </a>

                <a class="linkbox betslip-error" *ngIf="!!vm.info.remainingText">
                    <h4 class="theme-error-i" [innerHTML]="vm.info.remainingText"></h4>
                </a>
            </ng-container>
            <ng-container *msShowInEpcot="{ showInEpcot: true, module: module }">
                <ms-epcot-notification
                    *ngIf="!!vm.info.message"
                    [notificationHeaderTitle]="vm.info.message + ' ' + (vm.info.failedInfo ?? '')"
                    [notificationType]="'error'"></ms-epcot-notification>
                <ms-epcot-notification
                    *ngIf="!!vm.info.remainingText"
                    [notificationHeaderTitle]="vm.info.remainingText"
                    [notificationType]="'info'"></ms-epcot-notification>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngFor="let slip of vm.slips">
        <bs-digital-result-failed-slip [slip]="slip" [oddsDisplayFormat]="oddsDisplayFormat"></bs-digital-result-failed-slip>
    </ng-container>
</ng-container>
